import { useCallback } from 'react';
export function useTextFieldKeyboardTrigger(inputRef, onValueChange, openPicker, handleInsertVariable) {
  return useCallback(event => {
    var _input$selectionStart;
    if (event.key !== '{') return;
    const input = inputRef.current;
    if (!input) return;
    const cursorPos = (_input$selectionStart = input.selectionStart) !== null && _input$selectionStart !== void 0 ? _input$selectionStart : 0;
    const charBefore = input.value[cursorPos - 1];
    if (charBefore !== '{') return;
    event.preventDefault();
    const valueWithoutBrace = input.value.slice(0, cursorPos - 1) + input.value.slice(cursorPos);
    const savedPosition = cursorPos - 1;
    onValueChange(valueWithoutBrace);
    openPicker(input, handleInsertVariable, () => {
      const current = inputRef.current;
      if (!current) return;
      const val = current.value;
      const reinserted = val.slice(0, savedPosition) + '{{' + val.slice(savedPosition);
      onValueChange(reinserted);
      requestAnimationFrame(() => {
        if (!inputRef.current || inputRef.current !== current) return;
        current.focus();
        const newCursorPos = savedPosition + 2;
        current.setSelectionRange(newCursorPos, newCursorPos);
      });
    });
  }, [inputRef, onValueChange, openPicker, handleInsertVariable]);
}